import React, {useContext} from 'react'
import {useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {HotelCardContext} from 'components/HotelCardContext'
import {HotelMoreDetails} from 'components/SeoSRP/HotelMoreDetails/HotelMoreDetails'
import {useIsSeoSRP} from 'hooks/useIsSeoSRP'
import {getHotel, State} from 'modules/sapiSearch/selectors'
import {SelectedElement} from 'utils/selectedElement'

import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import {StarRating} from '@vio/atlas/StarRating'
import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'
import {ReviewRating} from '@vio/shared/src/search/ReviewRating'

import {PartialFiltersMatch} from '../../../HotelCard/PartialFiltersMatch/PartialFiltersMatch'

const HotelName = styled(Text)`
  word-wrap: break-word;
  flex-shrink: 0;
`

const RatingWrapper = styled.div`
  margin-left: -4px;
  padding-top: ${cssTheme.layout.spacing.s300};
`

export const PropertyDetails = () => {
  const {hotelId} = useContext(HotelCardContext)
  const hotelDetails = useSelector((state: State) => getHotel(state, hotelId))

  const isSeoSrp = useIsSeoSRP()

  if (!hotelId || !hotelDetails) {
    return (
      <Box padding="s400" display="flex" flexDirection="column" gap="s600">
        <div>
          <SkeletonLoader width={158} />
          <SkeletonLoader width={121} />
        </div>
        <div>
          <SkeletonLoader width={145} />
        </div>
      </Box>
    )
  }

  return (
    <Box display="flex" flexDirection="column" padding="s400" overflow="hidden">
      <div data-id={SelectedElement.StarRating}>
        <StarRating
          wrapperId={`HotelCardMobileStarRating-${hotelId}`}
          rating={hotelDetails.starRating}
          size="xs"
        />
      </div>
      <HotelName
        id={`HotelCardMobileHotelName-${hotelId}`}
        data-id={SelectedElement.HotelName}
        variant="titleL"
        tag="h2"
      >
        {hotelDetails.hotelName}
      </HotelName>
      <Text
        id={`HotelCardMobileLocation-${hotelId}`}
        data-id={SelectedElement.Location}
        variant="bodyS"
        colorPath="content.neutral.secondary"
      >
        {hotelDetails.placeDisplayName}
      </Text>
      <RatingWrapper>
        <ReviewRating
          variant="simple-default"
          singleLineLabels
          rating={hotelDetails.guestRating.overall}
          totalRatingCount={hotelDetails.reviewCount}
          hotelId={hotelDetails.objectID}
          dataId="ReviewRating"
        />
        {isSeoSrp && <HotelMoreDetails hotel={hotelDetails} />}
      </RatingWrapper>
      <PartialFiltersMatch isBasic hasBasicPropertyDetails={false} />
    </Box>
  )
}
